// extracted by mini-css-extract-plugin
export default {"loaderContainer":"auth-element_loaderContainer__QcsG-","errorComponent":"auth-element_errorComponent__Gvykf","errorContainer":"auth-element_errorContainer__IFDyZ"};